import { GRIPProvider } from "@nib/grip-react";
import Theme, { nib } from "@nib-components/theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { PropsWithChildren } from "react";

import { AuthProvider } from "src/components/Context/AuthProvider";
import { StoreProvider } from "src/components/Context/store-context";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: Infinity,
    },
  },
});

export const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <GRIPProvider
      gripConfig={{
        domain: process.env.GATSBY_AUTH_DOMAIN as string,
        clientId: process.env.GATSBY_AUTH_CLIENT_ID as string,
        audience: process.env.GATSBY_AUTH_AUDIENCE,
      }}
    >
      <Theme theme={nib}>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools />
            <StoreProvider>{children}</StoreProvider>
          </QueryClientProvider>
        </AuthProvider>
      </Theme>
    </GRIPProvider>
  );
};
